import Axios from "axios";
import {
  SET_BONUS_BANK_ADVICE_REPORT_LIST,
  UNSET_BONUS_BANK_ADVICE_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getBonusBankAdviceReport,
} from "@/store/api";

const state = {
  getBonusBankAdviceReport: [],
};

const getters = {
  getBonusBankAdviceReport(state) {
    return state.getBonusBankAdviceReport;
  },
};

const mutations = {
  [SET_BONUS_BANK_ADVICE_REPORT_LIST](state, data) {
    state.getBonusBankAdviceReport = data;
  },
  [UNSET_BONUS_BANK_ADVICE_REPORT_LIST](state) {
    state.getBonusBankAdviceReport = [];
  },
};

const actions = {
  getBonusBankAdviceReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getBonusBankAdviceReport}`, { params: data })
        .then((response) => {
          commit(SET_BONUS_BANK_ADVICE_REPORT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_BONUS_BANK_ADVICE_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

